(function () {
  function revealAll() {
    document.querySelectorAll('.previa-reveal').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  if (!('IntersectionObserver' in window)) {
    revealAll();
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );

  function observeAll(root) {
    (root || document).querySelectorAll('.previa-reveal:not(.is-visible)').forEach(function (el) {
      observer.observe(el);
    });
  }

  function init() {
    observeAll();

    // Watch for sections being added/replaced — covers the Shopify theme editor's
    // live AJAX section re-render on every settings change (text, price, images, etc.),
    // plus any other dynamic re-render (cart drawer, filters). Without this, elements
    // injected after the initial load stay stuck at opacity:0 forever (only the
    // section background shows, all text/cards appear to vanish).
    var mutationObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('.previa-reveal')) {
            observer.observe(node);
          }
          if (node.querySelectorAll) {
            observeAll(node);
          }
        });
      });
    });

    mutationObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Belt-and-suspenders: Shopify explicitly fires this when a section is
  // (re)rendered inside the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    observeAll(event.target);
  });
})();
